import React, { useEffect, useState } from "react";
import { Modal, FormGroup, Row, Col, CardBody, Card, Container, Label, Input } from "reactstrap";
import { Link, useLocation, useHistory } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage, useFormik } from 'formik';
import * as Yup from 'yup';
import { UserService } from "../../services/userService";
import 'toastr/build/toastr.min.css';
import { StoreService } from '../../services/storeService';
import toastr, { success } from 'toastr'
import { useParams } from 'react-router-dom';
import { Button } from "bootstrap";
import ModalAddAddress from "../user/ModalAddAddress";
import profile from "../../assets/images/adfavico.png";
import { deleteCart, deleteStoreFromCart } from '../../store/auth/cart/actions'
import { useDispatch, useSelector } from 'react-redux'
import { ApiConstants } from "../../common/apiConstants";
import { Redirect } from 'react-router-dom';
const idTienda_ = ApiConstants.ID_TIENDA;

export default function SendProducts(props) {
    //const user = useSelector(x => x.Login.user);
    const user = useSelector((state) => state.Login.user);
    
    const userService = new UserService();
    const storeService = new StoreService();
    
    const [lista, setLista] = useState([]);
    const [site, setSite] = useState([]);
    const params = useParams();
    const [modalInsertar, setInsertar] = useState(false);
    const [establishment, setEstablishment] = useState(false);
    const location = useLocation();
    const cart = useSelector(store => store.cart.countercart);
    const productsByStore = cart;
    const [addressId, setAddressId] = useState()
    const [area, setArea] = useState()
    const history = useHistory();
    const [selectValue, setSelectValue] = useState()
    const dispatch = useDispatch()
    const cantidadarticulos = localStorage.getItem('cantidadarticulos') || "0";
    const rawPersona = JSON.parse(localStorage.getItem('userInfo')) || {};

const persona = {
  id: rawPersona.id ?? 0,
  uid: rawPersona.uid ?? '0',
  clave: rawPersona.clave ?? '',
  email: rawPersona.email ?? '',
  fechaNacimiento: rawPersona.fechaNacimiento ?? '0001-01-01T00:00:00',
  idGenero: rawPersona.idGenero ?? 1,
  nivel: rawPersona.nivel ?? 'Cliente',
  nombres: rawPersona.nombres ?? '',
  apellidos: rawPersona.apellidos ?? '',
  tipoIdentificacion: rawPersona.tipoIdentificacion ?? '',
  telefono: rawPersona.telefono ?? '',
  numeroDocumento: rawPersona.numeroDocumento ?? '',
  totalPuntos: rawPersona.totalPuntos ?? 0,
  dateRegister: rawPersona.dateRegister ?? new Date().toISOString(),
  temporal: rawPersona.temporal ?? 'No',
  ipOrigen: rawPersona.ipOrigen ?? '127.0.0.1',
  deviceToken: rawPersona.deviceToken ?? 'ABC123XYZ',
  perfil: rawPersona.perfil ?? 1,
  aceptoTyC: rawPersona.aceptoTyC ?? true,
  autorizoTDP: rawPersona.autorizoTDP ?? true,
  nombrePerfil: rawPersona.nombrePerfil ?? 'Cliente Estándar',
  clienteCorp: rawPersona.clienteCorp ?? false,
  nit: rawPersona.nit ?? '900123456-7',
  autorizadoClienteCorp: rawPersona.autorizadoClienteCorp ?? false
};
    

    

// Estados principales
const [initialValues, setInitialValues] = useState({
    id: 0,
    idPersona: 0,
    idDireccion: 0,
    fecha: new Date(),
    observacion: '',
    idTienda: idTienda_,
    iva: 0,
    subTotal: 0,
    total: 0,
    tipoPago: "",
    nombreTipoPago: "",
    totalEnvio: 5000,
    userId: "0",
    dateRegister: new Date(),
    estado: "Pendiente",
    cantidadArticulos: cantidadarticulos,
    ipOrigen: "127.0.0.1",
    ivaMoneda: "$0",
    subTotalMoneda: "",
    totalMoneda: "",
    totalEnvioMoneda: "",
    nombreTienda: "",
    tipoEntrega: "Envio",
});
const [FinalValues, setFinalValues] = useState({


});

const [productosPorOrden, setProductosPorOrden] = useState([]);
const [estadosOrden, setEstadosOrden] = useState([]);
const [estadoOrden, setEstadoOrden] = useState([]);
const [productsToBuy, setProductsToBuy] = useState([]);
const [name, setName] = useState([]);
const [listaCiudades, setListaCiudades] = useState([]);
const [Referencia, setReferencia] = useState([]);
const [direccionSeleccionada, setDireccionSeleccionada] = useState(null);
const [productosFinales, setProductosFinales] = useState([]);
const [nombretienda, setnombretienda] = useState([]);

// Carga inicial de datos
useEffect(() => {
    const getSite = async () => {
        try {
            const data = await storeService.getSite(2);
            if (data) setSite(data);
        } catch (error) {
            console.error("Error en getSite:", error);
        }
    };

    const addressSaved = async () => {
        try {
            setInsertar(false);
            if (user?.id) {
                const lista = await userService.listAddress(user.id);
                setLista(lista);
            }
            const response = await userService.getCiudades('52');
            setListaCiudades(response);
        } catch (error) {
            console.error("Error en addressSaved:", error);
        }
    };
    getSite();
    addressSaved();
    const productos = Array.isArray(location?.state?.productos) ? location.state.productos : [];
    setProductsToBuy(productos);
}, []);

// Procesamiento de productos cuando cambian
useEffect(() => {
    if (productsToBuy?.length) {
        localStorage.setItem('productsToBuy', JSON.stringify(productsToBuy));

        const primerProducto = productsToBuy[0];

        // Llenar initialValues con los datos relevantes del primer producto
        setInitialValues((prev) => ({
            ...prev,
            idPersona: persona?.id || 0,
            idDireccion: persona?.direccionId || 0,
            observacion: 'Orden creada automáticamente',
            iva: primerProducto.Iva || 0,
            subTotal: productsToBuy.reduce((acc, prod) => acc + (prod.price * (prod.count || 1)), 0),
            total: productsToBuy.reduce((acc, prod) => acc + (prod.price * (prod.count || 1)), 0),
            tipoPago: primerProducto.tipoPago || "",
            nombreTipoPago: primerProducto.nombreTipoPago || "",
            totalEnvio: primerProducto.totalEnvio || 5000,
            userId: persona?.uid || "0",
            cantidadArticulos: productsToBuy.reduce((acc, prod) => acc + (prod.count || 1), 0).toString(),
            ivaMoneda: `$${primerProducto.Iva?.toFixed(2) || "0"}`,
            subTotalMoneda: `$${productsToBuy.reduce((acc, prod) => acc + (prod.price * (prod.count || 1)), 0).toFixed(2)}`,
            totalMoneda: `$${productsToBuy.reduce((acc, prod) => acc + (prod.price * (prod.count || 1)), 0).toFixed(2)}`,
            totalEnvioMoneda: `$${(primerProducto.totalEnvio || 0).toFixed(2)}`,
            nombreTienda: primerProducto.store || "",
        }));

        const productosOrdenados = productsToBuy.map((producto) => ({
            id: 0,
            idOrden: initialValues.id || 0,
            idProducto: producto.id,
            valorUnitario: producto.price,
            cantidadComprada: producto.count || 1,
            iva: producto.Iva || 0,
            descuento: producto.Descuento || 0,
            idTienda: producto.idStore,
            existencias: producto.existencia,
            referencia: producto.Referencia,
            tallaId: producto.talla?.id || null,
            caracteristicasModel: [
                {
                    nombre: "Talla",
                    valor: producto.talla?.talla || ""
                }
            ],
            informacionProducto: [
                {
                    id: producto.id,
                    descripcion: producto.name,
                    descuento: producto.Descuento || 0,
                    detalle: "Detalle no disponible",
                    iva: producto.Iva || 0,
                    referencia: producto.Referencia,
                    cantidad: producto.count || 1,
                    idCategoria: 1,
                    idCategoriaPadre: 0,
                    nombreCategoria: "Ropa",
                    valor: producto.price,
                    valorMoneda: producto.newPrice,
                    idTienda: producto.idStore,
                    nombreTienda: producto.store,
                    userId: persona?.uid || "0",
                    dateRegister: initialValues.fecha,
                    fotoPrincipal: producto.image,
                    fechaHastaPauta: "2025-12-31T00:00:00Z",
                    presentacion: "Unidad",
                    marca: "Marca Genérica",
                    calificacion: producto.rating,
                    garantia: "30 días",
                    terminosGarantia: "Aplican condiciones",
                    tiempoGarantia: "30 días",
                    valorCorp: 0,
                    descuentoCorp: 0,
                    ivaCorp: 0
                }
            ]
        }));

        setProductosPorOrden(productosOrdenados);

        setEstadosOrden([{
            id: 0,
            nombre: "pendiente",
            idOrden: initialValues.id || 0,
            fecha: initialValues.fecha || new Date().toISOString(),
            idEstadoOrden: 1,
            finalizado: false,
        }]);

        setEstadoOrden({
            id: 0,
            idOrden: initialValues.id || 0,
            fecha: initialValues.fecha || new Date().toISOString(),
            idEstado: 1,
            nombre: "pendiente",
            observaciones: "Orden creada exitosamente.",
        });
    }
}, [productsToBuy]);


useEffect(() => {
    if (productsToBuy?.length) {
        localStorage.setItem('productsToBuy', JSON.stringify(productsToBuy));

        const fechaActual = new Date().toISOString();

        const productos = productsToBuy.map((producto, index) => ({
            id: producto.id,
            descripcion: producto.name,
            descuento: producto.Descuento || 0,
            detalle: "Detalle no disponible",
            iva: producto.Iva || 0,
            referencia: producto.Referencia,
            cantidad: producto.count || 1,
            idCategoria: 1,
            nombreCategoria: "Ropa",
            valor: producto.price,
            valorMoneda: producto.newPrice,
            idTienda: producto.idStore,
            nombreTienda: producto.store,
            userId: persona?.uid || "0",
            dateRegister: initialValues.fecha || fechaActual,
            dateUpdate: initialValues.fecha || fechaActual,
            fotoPrincipal: producto.image,
            fechaHastaPauta: "2025-12-31T00:00:00Z",
            tiempoGarantia: "30 días",
            garantia: "30 días",
            terminosGarantia: "Aplican condiciones",
            publicar: "true",
            userUpdate: persona?.uid || "0",
            listaTagsVideoImagen: [
                {
                    idProductoCaracteristica: 1,
                    nombre: "Tag ejemplo",
                    valor: "Imagen"
                }
            ],
            caracteristicasModel: [
                {
                    nombre: "Talla",
                    valor: "Talla Unica"
                }
            ],
            valorPorTallasModel: [
                {
                    id: 9,
                    talla: "Talla Unica",
                    cantidad: producto.count || 1
                }
            ],
            valorCorp: 0,
            descuentoCorp: 0,
            ivaCorp: 0,
            terminosConticiones: "Sin condiciones adicionales",
            tratamientoDatosPersonales: "Autorizado",
            talla: {
                id: 9,
                talla: "Talla Unica",
                cantidad: producto.count || 1
            }
        }));

        setProductosFinales(productos);
    }
}, [productsToBuy]);



// Efecto para actualizar localStorage solo
useEffect(() => {
    if (productsToBuy?.length) {
        localStorage.setItem('productsToBuy', JSON.stringify(productsToBuy));
    }
}, [productsToBuy]);

// Servicios auxiliares
const addressSaved = async () => {
    try {
        setInsertar(false);
        if (user?.id) {
            const lista = await userService.listAddress(user.id);
            setLista(lista);
        }
        const response = await userService.getCiudades('52');
        setListaCiudades(response);
    } catch (error) {
        console.error("Error en addressSaved:", error);
    }
};

const mapDireccionPersona = (e) => ({
    id: e.idDireccionPersona,
    idPersona: e.id,
    barrio: e.barrio || "",
    esPrincipal: e.esPrincipal === "Sí" || e.esPrincipal === "true" ? "true" : "false",
    latitud: e.latitud || "",
    longitud: e.longitud || "",
    nombreRecibe: e.nombreRecibe,
    referencia: e.referencia,
    telefono: e.telefonoDireccion || e.telefonoContacto || "",
    userId: "0",
    dateRegister: new Date().toISOString(), // o algún valor real
    nomenclatura: e.nomenclatura,
    tipoIdRecibe: e.tipoIdentificacion || "NI", // asegúrate de tener esto
    numDocRecibe: e.numeroDocumento,
    ciudad: e.nomenclatura, // deberías mapearlo si lo tienes
    departamento: "nariño" // igual que ciudad
});

const mapDatosGeograficos= (e) => ({
  countyId: e.countyId || "001",
  municipio: e.nomenclatura || "nariño",
  stateId: e.stateId || "52",
  
 
});
// Handlers de selección
const getValue = (e) => {
    setName(e.nomenclatura);
    setAddressId(e.idDireccionPersona);
    setReferencia(e.referencia);
    
    const direccionFormateada = mapDireccionPersona(e);
    setDireccionSeleccionada(direccionFormateada);

    console.log("REFERENCIA", e.referencia);
    console.log("DIRECCIÓN FORMATEADA", direccionFormateada);
};

const getValueDeptSelect = async (e) => {
    const response = await userService.getCiudades(e.target.value);
    setListaCiudades(response);
};

const getValueSelect = (e) => {
    setSelectValue(e.target.value);
};




const onSubmit = async (values) => {
    if (!addressId) {
        toastr.error("Debe escoger una dirección");
        return;
    }

    const ivaTotal = productsByStore.reduce((a, b) => a + (b.count * b.Iva), 0);
    const datosExtra = mapDatosGeograficos(direccionSeleccionada);
    
    const request = {
        ...initialValues,
        idDireccion: addressId,
        observacion: area || "Sin observaciones",
        iva: ivaTotal,
        subTotal: productsByStore.reduce((a, b) => a + b.price * b.count, 0) - ivaTotal,
        productosPorOrden,
        estadosOrden,
        productos: productosFinales, 
        direccionPersona: direccionSeleccionada, // ← AQUÍ CAMBIA
        persona: persona,
        estadoOrden,
        municipio: selectValue,
        ...datosExtra
        
    };

    try {
        const response = await userService.addOrder(request);
        toastr.success("Orden agregada exitosamente");
        if (request.persona.autorizadoClienteCorp) {
            dispatch(deleteCart());
        }
        history.push({
            pathname: `/PayMethod/${response.idOrden}`,
            state: {
                addressChecked: name,
                paramId: params.id,
                productsToBuy: productsToBuy
            }
        });
    } catch (error) {
        console.error("Error al crear la orden:", error);
        toastr.info("No se creó la orden");
    }
};

return (
    <React.Fragment>
        <div className="scroll-wrapper" style={{ maxHeight: '100vh', overflowY: 'auto' }}>
            <div className="home-btn d-none d-sm-block">
                <Link to="/" className="text-dark">
                    <i className="bx bx-home h2"></i>
                </Link>
            </div>
            <div className="account-pages mt-5 mb-1 pt-sm-5">
                <Container style={{ backgroundColor: 'transparent' }}>
                    <Row className="justify-content-center">
                        <Col md={9} lg={10} xl={8}>
                            <Card style={{ height: "auto" }}>
                                <Row className="d-flex justify-content-center pt-4 pb-3">
                                    <label htmlFor="" className="control-label m-3"><h5>Envió Productos</h5></label>
                                </Row>
                                <CardBody>
                                    <div className="p-2">
                                        {site.estado ? (
                                            <Label>
                                                <input
                                                    className="mb-4"
                                                    type="checkbox"
                                                    id="checkE"
                                                    checked={establishment}
                                                    onChange={() => setEstablishment(!establishment)}
                                                />
                                                Pedir en establecimiento
                                            </Label>
                                        ) : (
                                            <div></div>
                                        )}

                                        {establishment ? (
                                            <div>
                                                <h6>Pedido en establecimiento</h6>
                                                <hr />
                                                <div className="text-aling-center mb-3 ml-4">
                                                    <p>
                                                        Su orden será entregada en el Supermercado BASTET - TIENDA DERMATOLOGICA.
                                                        Por favor indique fecha y hora
                                                    </p>
                                                    <input type="date" className="mr-4" />
                                                    <input type="time" />
                                                </div>
                                            </div>
                                        ) : (
                                            <div>
                                                <h6>Escoge una dirección</h6>
                                                <hr />
                                                <div className="mt-3 overflow-y-scroll" style={{ height: "20vh" }}>
                                                    <ul className="list-group">
                                                        {lista.map((c, key) => (
                                                            <li className="list-group-item" key={key}>
                                                                <Row>
                                                                    <Col md={12}>
                                                                        <Label for="checkAddress">
                                                                            <input
                                                                                className="mt-4 mr-3"
                                                                                type="radio"
                                                                                name="checkAddress"
                                                                                value={c}
                                                                                onClick={() => getValue(c)}
                                                                            />
                                                                            {c.referencia} ({c.nomenclatura})
                                                                        </Label>
                                                                    </Col>
                                                                </Row>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                                <Row className="m-4">
                                                    <u style={{ color: '#47BFC0' }}>
                                                        <span onClick={() => setInsertar(true)} style={{ color: '#47BFC0' }}>
                                                            Agregar otra dirección
                                                        </span>
                                                    </u>
                                                </Row>
                                            </div>
                                        )}

                                        <Row className="m-4 mt-4">
                                            <Label>Departamento:</Label>
                                            <select
                                                className="form-control form-control-lg"
                                                onChange={(e) => getValueDeptSelect(e)}
                                            >
                                                <option value="52">Nariño</option>
                                                <option value="19">Cauca</option>
                                                <option value="86">Putumayo</option>
                                            </select>
                                        </Row>

                                        <Row className="m-4 mt-4">
                                            <Label>Ciudad:</Label>
                                            <select
                                                className="form-control form-control-lg"
                                                onChange={(e) => getValueSelect(e)}
                                            >
                                                {listaCiudades.map((x, i) => (
                                                    <option key={i} value={x.municipio}>
                                                        {x.municipio}
                                                    </option>
                                                ))}
                                            </select>
                                        </Row>

                                        <div className="form-group mt-4">
                                            <label htmlFor="exampleFormControlTextarea1">
                                                Descipción de la orden
                                            </label>
                                            <textarea
                                                onChange={(e) => setArea(e.target.value)}
                                                className="form-control"
                                                id="Descripcion orden"
                                                rows="3"
                                                placeholder="Escribe aquí las instrucciones, sugerencias y observaciones de tu pedido"
                                            ></textarea>
                                        </div>

                                        <Formik initialValues={initialValues} onSubmit={onSubmit}>
                                            <Form>
                                                <div>
                                                    <button
                                                        className="boton3-fanero btn-block text-center mb-4"
                                                        type="submit"
                                                    >
                                                        Ir a pagar
                                                    </button>
                                                </div>
                                            </Form>
                                        </Formik>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Modal isOpen={modalInsertar}>
                <div className="modal-header">
                    <h5 className="modal-title mt-0" id="mySmallModalLabel">
                        <img src={profile} alt="" className="img-fluid" style={{ height: '50px' }} />
                        <label htmlFor="Nomenclatura" className="control-label m-3">
                            Crear Dirección
                        </label>
                    </h5>
                    <button
                        onClick={() => setInsertar(false)}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <ModalAddAddress addressSaved={addressSaved} />
                </div>
            </Modal>
        </div>
    </React.Fragment>
);

}

